import React, { useMemo } from 'react';
import './style.scss';
import Button from '../controls/Button/index.js';

const ButtonsContainer = ({
  items,
  className = 'buttons-container-default',
  buttonClassName = 'buttons-container-default-button',
}) => {
  const buttons = useMemo(() => {
    const unfiltered = Array.isArray(items) ? items : [{ fields: { link: items } }];
    return unfiltered.filter((btn) => btn?.fields?.link?.value?.href);
  }, [items]);

  if (buttons?.length === 0) return null;

  return (
    <div className={className}>
      {buttons
        .filter((btn) => btn?.fields?.link?.value?.href)
        .map((btn, index) => (
          <Button link={btn.fields.link} key={index} className={buttonClassName} />
        ))}
    </div>
  );
};

export default ButtonsContainer;
